import styled from '@emotion/styled';
import { nike } from '@nike/nike-design-tokens';

const { podiumCdsColorGrey300 } = nike;

const stepCSS = styled('div');
export const StepCss = stepCSS`
  display: flex;
  align-items: center;
  height: 25px;
  padding-left: 8px;
  padding-right: 8px;
`;

const stepConnectorCSS = styled('span');
export const StepConnectorCss = stepConnectorCSS`
  flex: 1 1 auto;
  border-color: ${podiumCdsColorGrey300};
  border-top-style: solid;
  border-top-width: 1px;
`;
